export const baseThemeOptions = {
    palette: {
        primary: {
            main: '#3498db', // Blue
            light: '#42a5f5',
            dark: '#1565c0',
        },
        secondary: {
            main: '#9c27b0', // Purple
            light: '#ba68c8',
            dark: '#7b1fa2',
        },
        background: {
            default: '#f5f5f5', // Light gray background
            paper: '#ffffff',   // White for cards/paper
        },
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
        h1: { color: '#212121' },
        h2: { color: '#212121' },
        h3: { color: '#212121' },
        h4: { color: '#212121' },
        h5: { color: '#212121' },
        h6: { color: '#212121' },
        subtitle1: { color: '#212121' },
        subtitle2: { color: '#424242' },
        body1: { color: '#212121' },
        body2: { color: '#424242' },
        button: { color: '#212121' },
        caption: { color: '#616161' },
        overline: { color: '#616161' }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                color: 'textPrimary'
            }
        }
    },
};



export const denseComponentStyles = {
    MuiCard: {
        styleOverrides: {
            root: {
                boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.1)',
                '&.MuiPaper-elevation1': {
                    boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.1)',
                },
                '&.MuiPaper-elevation2': {
                    boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.15)',
                },
                '&.MuiPaper-elevation3': {
                    boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.15)',
                }
            }
        }
    },
    MuiSelect: {
        styleOverrides: {
            select: {
                padding: '6px 12px',
                fontSize: '0.8125rem',
                minHeight: '32px',
                boxSizing: 'border-box',
            },
            icon: {
                fontSize: '1rem', // Ensures consistent icon size
            }
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                minHeight: '32px',
                padding: '6px 12px',
                fontSize: '0.8125rem',
            },
        },
    },
    MuiMenu: {
        styleOverrides: {
            paper: {
                maxHeight: '250px',
                '& .MuiMenu-list': {
                    padding: '4px 0',
                },
            },
            list: {
                padding: 0,
            },
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: '4px',
                },
                fontSize: '0.8125rem',
            },
            input: {
                padding: '8px 12px',
                height: '1.125rem',
            },
            inputSizeSmall: {
                padding: '6px 8px',
                fontSize: '0.8125rem',
                height: '1.125rem',
            },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                fontSize: '0.8125rem',
                marginBottom: '4px',
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -6px) scale(0.75)',
                },
            },
        },
    },
    MuiAutocomplete: {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-root': {
                    padding: '2px 8px 2px 6px',
                    minHeight: '40px',
                },
                '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    padding: '0px 8px 0px 6px',
                    minHeight: '32px',
                },
                '& .MuiAutocomplete-input': {
                    padding: '6px 4px 6px 0px !important',
                    fontSize: '0.8125rem',
                },
                '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
                    padding: '0 !important',
                },
            },
            inputRoot: {
                '&[class*="MuiOutlinedInput-root"]': {
                    paddingTop: '6px !important',
                    paddingBottom: '6px !important',
                },
                '&[class*="MuiOutlinedInput-root"][class*="MuiInputBase-sizeSmall"]': {
                    paddingTop: '4px !important',
                    paddingBottom: '4px !important',
                },
            },
            tag: {
                margin: '2px',
                height: '22px',
                '& .MuiChip-label': {
                    fontSize: '0.6875rem',
                    padding: '0 6px',
                },
                '& .MuiChip-deleteIcon': {
                    fontSize: '14px',
                    marginRight: '2px',
                },
            },
            option: {
                padding: '8px 12px',
                fontSize: '0.8125rem',
                minHeight: '32px',
            },
            listbox: {
                padding: '4px 0',
                maxHeight: '300px', // Consistent with MuiMenu maxHeight
            },
            clearIndicator: {
                padding: '4px',
            },
            popupIndicator: {
                padding: '4px',
            },
        },
    },
    MuiFormControl: {
        styleOverrides: {
            root: {
                '& .MuiInputLabel-root': {
                    transform: 'translate(14px, 10px) scale(1)',
                    '&.Mui-focused, &.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)',
                    },
                },
            },
        },
    },
    MuiCheckbox: {
        styleOverrides: {
            root: {
                padding: '4px',
                '&.Mui-checked': {
                    padding: '4px',
                },
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                marginLeft: '-4px',
                marginRight: '8px',
            },
            label: {
                fontSize: '0.8125rem',
            },
        },
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                '&.MuiPaper-elevation1': {
                    boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.1)',
                },
                '&.MuiPaper-elevation2': {
                    boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.15)',
                },
                '&.MuiPaper-elevation3': {
                    boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.15)',
                },
                '&.MuiPaper-elevation4': {
                    boxShadow: '0px 3px 8px 0px rgba(0,0,0,0.15)',
                },
                '&.MuiPaper-elevation5': {
                    boxShadow: '0px 4px 10px 0px rgba(0,0,0,0.15)',
                },
                '&.MuiMenu-paper': {
                    maxHeight: '200px', // Ensures consistency with MuiMenu
                    scrollbarWidth: 'thin',
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#bdbdbd',
                        borderRadius: '3px',
                    },
                },
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: {
                padding: '4px 10px',
                fontSize: '0.8125rem',
                minHeight: '32px',
            },
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: {
                padding: '6px',
            },
            sizeSmall: {
                padding: '4px',
            },
        },
    },
};
